import request from '@/util/request'

const state = {}
const getters = {}
const actions = {
  fetchCallRecording({getters}, {recordingId}) {
    return request({
      url: `/calls/recording/${recordingId}`,
      method: 'get',
    }).then(response => response.signedUrl)
  },
  searchByPhone({getters}, {phone}) {
    return request({
      url: `/companies/search/${phone}`,
      method: 'get',
    })
  },
  logCall({getters}, data) {
    return request({
      url: `/calls/log-call`,
      method: 'post',
      data,
    })
  },
}
const mutations = {}

export default {
  namespaced: false,
  state,
  getters,
  actions,
  mutations,
}
